
import React, { useEffect, useState } from 'react';
import S3PrivateHtmlViewer from './S3PrivateHtmlViewer';

// Main App component that contains the two-tab view


const HtmlRenderer = () => {
    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/mmm_output1.html`)
            .then((res) => {
                if (!res.ok) throw new Error('Failed to fetch HTML');
                return res.text();
            })
            .then(setHtmlContent)
            .catch((err) => {
                console.error('Error loading HTML:', err);
                setHtmlContent('<p>Failed to load content.</p>');
            });
    }, []);

    return (
        <div
            className="html-container"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
};

const HtmlRenderer2 = () => {
    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/mmm_output2.html`)
            .then((res) => {
                if (!res.ok) throw new Error('Failed to fetch HTML');
                return res.text();
            })
            .then(setHtmlContent)
            .catch((err) => {
                console.error('Error loading HTML:', err);
                setHtmlContent('<p>Failed to load content.</p>');
            });
    }, []);

    return (
        <div
            className="html-container"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
};

export default function MmmTabs() {
    // State to manage the active tab. 'tab1' is active by default.
    const [activeTab, setActiveTab] = useState('tab1');

    return (
        // Main container for the tab view, now aligned to top-left and full width
        <div className="flex flex-col w-full bg-gray-100 dark:bg-black  font-sans"> {/* Removed centering classes */}
            <div className="w-full bg-white  dark:bg-black  shadow-lg rounded-lg overflow-hidden">
                {/* Tab buttons container */}
                <div className="flex border-b border-gray-200">
                    {/* Tab 1 Button */}
                    <button
                        // Conditional styling for the active tab
                        className={` py-3 px-4 text-center text-lg font-medium transition-colors duration-200
                       ${activeTab === 'tab1'
                                ? 'text-indigo-600 border-b-2 border-indigo-600 bg-indigo-50'
                                : 'text-gray-600 hover:text-indigo-600 hover:bg-gray-50 dark:text-white'
                            } focus:outline-none rounded-tl-lg`} // Rounded top-left corner
                        onClick={() => setActiveTab('tab1')} // Set active tab to 'tab1' on click
                    >
                        Modeling Report
                    </button>

                    {/* Tab 2 Button */}
                    <button
                        // Conditional styling for the active tab
                        className={` py-3 px-4 text-center text-lg font-medium transition-colors duration-200
                       ${activeTab === 'tab2'
                                ? 'text-indigo-600 border-b-2 border-indigo-600 bg-indigo-50'
                                : 'text-gray-600 hover:text-indigo-600 hover:bg-gray-50 dark:text-white'
                            } focus:outline-none rounded-tr-lg`} // Rounded top-right corner
                        onClick={() => setActiveTab('tab2')} // Set active tab to 'tab2' on click
                    >
                        Optimization Report
                    </button>
                </div>

                {/* Tab Content Area */}
                <div>
                    {/* Content for Tab 1, shown only when activeTab is 'tab1' */}
                    {activeTab === 'tab1' && (
                        <div className="text-gray-800">

                            <div style={{ border: '1px solid #ddd', borderRadius: '8px', marginTop: '20px' }}>
                                {/* <iframe
                                    src={`${process.env.PUBLIC_URL}/mmm_output1_responsive.html`}
                                    style={{ width: '100%', height: '800px', border: 'none' }}
                                    title="HTML Viewer"
                                /> */}

                                <S3PrivateHtmlViewer filename={'htmlfiles/mmm_output1_responsive.html'} />

                            </div>
                        </div>
                    )}

                    {/* Content for Tab 2, shown only when activeTab is 'tab2' */}
                    {activeTab === 'tab2' && (
                        <div className="text-gray-800">

                            <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '1px', marginTop: '20px' }}>

                                {/* <iframe
                                    src={`${process.env.PUBLIC_URL}/mmm_output2_responsive.html`}
                                    style={{ width: '100%', height: '800px', border: 'none' }}
                                    title="HTML Viewer"
                                /> */}

                                <S3PrivateHtmlViewer filename={'htmlfiles/mmm_output2_responsive.html'} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
